import { useRouter } from '../router';
import { useLocalization } from '@/i18n';
import { VueShowdownPlugin } from 'vue-showdown';

export const pluginsWrapper = (shouldUseRouter: boolean = false) => ({
  install(GivenVue: any) {
    const Vue = GivenVue;
    const { i18n } = useLocalization();
    Vue.use(i18n);
    if (shouldUseRouter) {
      const { router } = useRouter();
      Vue.use(router);
    }
    Vue.use(VueShowdownPlugin, {
      flavor: 'github',
      options: {
        emoji: true,
      },
    });
    return Vue;
  },
});
